import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Templates from "./components/Templates";
import SuperCareer from "./pages/Templates/SuperCareer/SuperCareer";
import SuperCareerTwo from "./pages/Templates/SuperCareerTwo/SuperCareerTwo";
import IWD from "./pages/Templates/IWD/IWD";
import CareerFair from "./pages/Templates/Career-fair/CareerFair";
import OneForce from "./pages/Templates/OneForce/OneForce";
import ConfamJara from "./pages/Templates/ConfamJara/ConfamJara";
// import Header from "./components/Header";
import Home from "./pages/Home";

function App() {
  return (
    <Router basename="/meme">
      <div className="App">
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/templates" component={Templates} />
          <Route exact path="/templates/super-career" component={SuperCareer} />
          <Route exact path="/templates/super-career-two" component={SuperCareerTwo} />
          <Route exact path="/templates/iwd" component={IWD} />
          <Route exact path="/templates/career-fair" component={CareerFair} />
          <Route exact path="/templates/oneforce" component={OneForce} />
          <Route exact path="/templates/confamjara" component={ConfamJara} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
